export default "__VITE_ASSET__BKz1K9Up__"